import { ApiTypes } from "types"

export type ScheduleBucketKey =
  keyof ApiTypes.Res.MonitoringHistoricalDataBucket["filters#schedule_type_count"]["buckets"]

const getScheduleDataArray = (historicalData: ApiTypes.Res.MonitoringHistoricalDataBucket[], docsCount: number) => {
  return historicalData
    .map(item => {
      const scheduleData = item["filters#schedule_type_count"].buckets

      const maxBucketName = Object.entries(scheduleData).reduce(
        (max, [key, value]) => {
          const maxValue = scheduleData[max as keyof typeof scheduleData]?.doc_count || 0
          return value.doc_count > maxValue ? key : max
        },
        Object.keys(scheduleData)[0] || "",
      )

      if (scheduleData[maxBucketName as keyof typeof scheduleData]?.doc_count === 0) {
        return { type: "none" as ScheduleBucketKey, value: docsCount }
      }

      return { type: maxBucketName as ScheduleBucketKey, value: docsCount }
    })
    .reduce(
      (acc, curr) => {
        if (acc.length === 0) {
          return [curr]
        }

        const lastItem = acc[acc.length - 1]
        if (lastItem.type === curr.type) {
          acc[acc.length - 1].value += curr.value
          return acc
        } else {
          return [...acc, curr]
        }
      },
      [] as { type: ScheduleBucketKey; value: number }[],
    )
}

export default getScheduleDataArray
